import { render, staticRenderFns } from "./baseDataInfo.vue?vue&type=template&id=2e50bc45&scoped=true"
import script from "./baseDataInfo.vue?vue&type=script&lang=js"
export * from "./baseDataInfo.vue?vue&type=script&lang=js"
import style0 from "./baseDataInfo.vue?vue&type=style&index=0&id=2e50bc45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e50bc45",
  null
  
)

export default component.exports